import { gql } from "@apollo/client";

export const CREATE_VENUE = gql`
  mutation createVenue($createVenueInput: CreateVenueInput!) {
    createVenue(createVenueInput: $createVenueInput) {
      id
    }
  }
`;
